import axios from 'axios';
import {
  Decision,
  Customers,
  Lawyer,
  Domain,
  Juridiction,
  Ville,
} from '../../entity/entity.types';

export async function fetchLawFirmKeywords(
  lawOfficeIdGroup: string,
): Promise<{ keywords: string[] }> {
  return (
    await axios.get('/getLawFirmKeywords', {
      params: {
        lawOfficeIdGroup,
      },
    })
  ).data;
}

export async function fetchLawFirmTopDecisions(
  lawOfficeIdGroup: string,
): Promise<Decision[]> {
  return (
    await axios.get('/getLawFirmTopDecisions', {
      params: {
        lawOfficeIdGroup,
      },
    })
  ).data.arrets;
}

export async function fetchLawFirmCustomers(
  lawOfficeIdGroup: string,
): Promise<Customers> {
  return (
    await axios.get('/getLawFirmCustomers', {
      params: {
        lawOfficeId: lawOfficeIdGroup,
      },
    })
  ).data;
}

export async function fetchLawFirmLawyers(
  lawOfficeId: string,
): Promise<{ lawyers: Lawyer[] }> {
  return (await axios.get(`/api/law_firms/${lawOfficeId}/lawyers`)).data;
}

export async function fetchLawFirmDecisions(
  lawOfficeId: string,
): Promise<{
  domains: Array<Domain>;
  juridictions: Array<Juridiction>;
  villes: Array<Ville>;
  decisionCount: number;
}> {
  return (
    await axios.get('/getLawFirmDecisions', {
      params: {
        lawOfficeId,
      },
    })
  ).data;
}
